var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" "+_vm._s(`(${_vm.formatAuthors(_vm.authors) .filter(author => author) .join(" ")} ${_vm.year === 0 ? "No year specified" : _vm.year}. ${ _vm.title ? _vm.title : "No title specified" }.)`)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }